import { type SocketMachineContext } from '../../../network-state-machine-context';
import {
  type SyncEvent,
  type SyncFetchingEvent,
} from '../../../network-state-machine-events';

export async function syncingFetchSnapshotAsync<
  T extends Pick<SocketMachineContext, 'relayDetails' | 'socketFetchSnapshot'>
>(ctx: T, signal: AbortSignal): Promise<SyncFetchingEvent> {
  if (!ctx.relayDetails) {
    throw new Error('Missing relay details in context');
  }
  const remoteDocument = await ctx.socketFetchSnapshot(signal);
  return {
    type: 'synced',
    remoteDocument,
    relayDetails: ctx.relayDetails,
  };
}

export async function syncingFetchStepsAsync<
  T extends Pick<
    SocketMachineContext,
    'relayDetails' | 'remoteDocument' | 'socketFetchSteps'
  >
>(ctx: T, signal: AbortSignal): Promise<SyncFetchingEvent> {
  if (!ctx.relayDetails) {
    throw new Error('Missing relay details in context');
  }
  if (!ctx.remoteDocument) {
    throw new Error('Missing remote document in context');
  }

  const remoteDocument = await ctx.socketFetchSteps(ctx.remoteDocument, signal);

  return {
    type: 'synced',
    remoteDocument,
    relayDetails: ctx.relayDetails,
  };
}

export async function syncingApplyChangesAsync<
  T extends Pick<
    SocketMachineContext,
    'relayDetails' | 'remoteDocument' | 'socketApplyChanges'
  >
>(ctx: T): Promise<SyncFetchingEvent> {
  if (!ctx.relayDetails) {
    throw new Error('Missing relay details in context');
  }
  if (!ctx.remoteDocument) {
    throw new Error('Missing remote document in context');
  }

  const remoteDocument = ctx.socketApplyChanges(ctx.relayDetails.url, ctx.remoteDocument);

  return {
    type: 'synced',
    remoteDocument,
    relayDetails: ctx.relayDetails,
  };
}

export async function syncingUpdateChangesAsync<
  T extends Pick<
    SocketMachineContext,
    'remoteDocument' | 'socketUpdateChanges' | 'debounce'
  >
>(ctx: T, signal: AbortSignal): Promise<SyncEvent> {
  if (!ctx.remoteDocument) {
    throw new Error('Missing remote document in context');
  }

  ctx.socketUpdateChanges(ctx.remoteDocument, ctx.debounce.attempt, signal);

  return {
    type: 'synced',
  };
}
